export default {
    cityFrom: 'From',
    cityTo: 'To',
    carTypes: 'Body type',
    carryingCapacity: 'Carrying capacity',
    bodyVolume: 'Body volume',
    tons: 't',
    meters: 'm',
    free: 'Free',
    outsideRussia: ' for directions outside of Russia. ',
    try: 'Try: '
};
